import {
  Icon,
  Button,
  Dialog,
  FormGroup,
  Input,
  Select,
  Uploader,
} from '@tencent/spaui';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { RPCFactory } from '../../../../utils/RequestUtil';

// 小程序相关数据结构
const wechatMsg = {
  messageType: 'miniprogram',
  // cosKey: '',
  miniprogramTitle: '',
  miniprogramAppId: '',
  miniprogramPage: '',
  isXundaMiniprogram: 1,
  xundaManufacturerId: '',
  xundaManufacturerName: '',
  miniprogramPicUrl: '',
};
const manufactureList = {
  xundaManufactureList: [{
    xundaManufactureId: 567,
    xundaManufactureName: '宝马',
    appId: '2q32323',
  }, {
    xundaManufactureId: 3245,
    xundaManufactureName: '奥迪',
    appId: '325423sdf',
  }, {
    xundaManufactureId: 456,
    xundaManufactureName: '沃尔沃',
    appId: '2w3ewe',
  }]
};
const pageList = {
  pageList: [{
    pageName: '首页',
    picUrl: 'https://ui.tad.woa.com/pic/300x300',
    path: '/index',
  }, {
    pageName: '详情页',
    picUrl: 'https://ui.tad.woa.com/pic/300x300',
    path: '/detail',
  }],
};
const jumpUrl = 'https://docs.qq.com/doc/DYmxCR2NxY0NXYWNT';
const miniprogramTypes = [{ label: '讯达小程序', value: 1 }, { label: '其他小程序', value: 0 }];
const WechatEditDialog = (props) => {
  const [wechatMsgInfo, setWechatMsgInfo] = useState(props.wechatMsgInfo || wechatMsg); // 小程序
  const [errorMessage, setErrorMessage] = useState('');
  const [xundaManufactureList, setXundaManufactureList] = useState([]);
  const [xundaMiniprogramPageList, setXundaMiniprogramPageList] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [operating, setOperating] = useState(false);
  const [check, setCheck] = useState(false);
  useEffect(() => {
    // setXundaManufactureList(manufactureList.xundaManufactureList);
    RPCFactory.wechatWelcome.getManufacture()
    .done((data) => {
      setXundaManufactureList(data.xundaManufactureList);
    })
    .fail((ret, msg) => {
      window.alert(`服务器请求出错，出错信息：${msg}`);
    });
  }, []);
  useEffect(() => {
    setWechatMsgInfo(wechatMsg);
    setSelectedImage([]);
    setCheck(false);
  }, [props.show]);
  useEffect(() => {
    if (!!wechatMsgInfo.xundaManufacturerId) {
      // setXundaMiniprogramPageList(pageList.pageList);
      const params = {
        xundaManufactureId: wechatMsgInfo.xundaManufacturerId,
        pageIndex: 1,
        pageSize: 100,
      };
      RPCFactory.wechatWelcome.getMiniprogramPages(params)
      .done((data) => {
        setXundaMiniprogramPageList(data.entities);
      })
      .fail((ret, msg) => {
        window.alert(`服务器请求出错，出错信息：${msg}`);
      });
    }
  }, [wechatMsgInfo.xundaManufacturerId]);
  const handleSubmit = () => {
    setCheck(true);
    if (!wechatMsgInfo.isXundaMiniprogram && !wechatMsgInfo.miniprogramPicUrl.length) {
      alert("请上传小程序封面");
    }
    if (
      !wechatMsgInfo.miniprogramTitle.length
      || !wechatMsgInfo.miniprogramAppId.length
      || !wechatMsgInfo.miniprogramPage.length
      || (!!wechatMsgInfo.isXundaMiniprogram && !wechatMsgInfo.xundaManufacturerId)
      || (!!wechatMsgInfo.isXundaMiniprogram && !wechatMsgInfo.xundaManufacturerName.length)
      || (!wechatMsgInfo.isXundaMiniprogram && !wechatMsgInfo.miniprogramPicUrl.length)
    ) {
      return;
    }
    let newWechatInfo = wechatMsgInfo;
    if (wechatMsgInfo.isXundaMiniprogram) {
      newWechatInfo = { ... _.omit(wechatMsgInfo, 'cosKey')};
    }
    props.onSubmit(newWechatInfo);
    props.onCancel();
  };
  const handleWelcomeMiniprogramInfoChange = (typeValuePairs) => { // ({ type, value }) => {
    const newWechatMsgInfo = { ...wechatMsgInfo };
    typeValuePairs.forEach((typeValue) => {
      const { type, value } = typeValue;
      newWechatMsgInfo[type] = value;
      if (type === 'xundaManufacturerId') {
        // 设置厂商，需要同时设置厂商名称及appid
        const manufactureInfoList = xundaManufactureList.filter(item => item.xundaManufactureId === value);
        if (manufactureInfoList.length > 0) {
          const manufactureInfo = manufactureInfoList[0];
          newWechatMsgInfo['xundaManufacturerName'] = manufactureInfo.xundaManufactureName;
          newWechatMsgInfo['miniprogramAppId'] = manufactureInfo.appId;
        }
      } else if (type === 'miniprogramPage' && wechatMsgInfo.isXundaMiniprogram) {
        // 选择小程序页面地址，需要同时设置小程序首页及小程序首页图片
        const miniprogramPageInfoList = xundaMiniprogramPageList.filter(item => item.path === value);
        if (miniprogramPageInfoList.length > 0) {
          const miniprogramPageInfo = miniprogramPageInfoList[0];
          newWechatMsgInfo['miniprogramTitle'] = miniprogramPageInfo.pageName;
          newWechatMsgInfo['miniprogramPage'] = miniprogramPageInfo.path;
          newWechatMsgInfo['miniprogramPicUrl'] = miniprogramPageInfo.picUrl;
        }
      }
    });

    setWechatMsgInfo(newWechatMsgInfo);
  };
  
  const handleUploadComplete = (response = {}, fileInfo = {}, fileId) => {
    const { data } = response;
    if (data) {
      handleWelcomeMiniprogramInfoChange([
        { type: 'miniprogramPicUrl', value: data.mediaUrl },
        { type: 'cosKey', value: data.cosKey },
        { type: 'imgName', value: fileInfo.name }
      ]);
      setSelectedImage([Object.assign({
        url: data.mediaUrl,
        name: fileInfo.name,
      })]);
      setErrorMessage('');
    } else {
      setErrorMessage(response.msg);
    }
    setOperating(false);
  };
  const handleDelete = (e, data) => {
    handleWelcomeMiniprogramInfoChange([
      { type: 'miniprogramPicUrl', value: '' },
      { type: 'cosKey', value: '' },
      { type: 'imgName', value: '' }
    ]);
    setSelectedImage([]);
  };
  return (
    <Dialog
      // useNewUI
      backdrop
      enabledBackdropClose
      onSubmit={handleSubmit}
      onCancel={props.onCancel}
      onClose={props.onCancel}
      show={props.show}
      type="normal"
      className="add-welcome-wechat-msg"
      title={'添加小程序消息'}
      style={{ width: '580px' }}
    >
      <div className="message-setting form-list-normal wechat-dialog">
        <div className="lump lump-nohd">
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <span className="info-tt">选择小程序</span>
                <div className="info-des">
                  <Select
                    className='select-mini-program-type'
                    placeholder='请选择'
                    data={miniprogramTypes}
                    value={wechatMsgInfo.isXundaMiniprogram}
                    onChange={(e, value) => handleWelcomeMiniprogramInfoChange([{ type: 'isXundaMiniprogram', value }])}
                  />
                  <span className="wechat-description">必须是关联到企业的小程序应用，</span>
                  <a href={jumpUrl} target="_blank">查看关联方法</a>
                </div>
              </li>
              {wechatMsgInfo.isXundaMiniprogram === 1 && <li className="infolist">
                <span className="info-tt">车讯达厂商</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.xundaManufacturerId?.length ===0 ? "请选择车讯达厂商" : ''}
                  >
                    <Select
                      className='select-manufacture'
                      placeholder='请选择车讯达厂商'
                      data={xundaManufactureList}
                      value={wechatMsgInfo.xundaManufacturerId}
                      onChange={(e, value) => {
                        handleWelcomeMiniprogramInfoChange([{ type: 'xundaManufacturerId', value }]);
                      }}
                      labelFieldName='xundaManufactureName'
                      valueFieldName='xundaManufactureId'
                    />
                  </FormGroup>
                </div>
              </li>}
              {wechatMsgInfo.isXundaMiniprogram === 1 && <li className="infolist">
                <span className="info-tt">小程序页面</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.miniprogramPage?.length ===0 ? "请选择小程序页面" : ''}
                  >
                    <Select
                      className='select-mini-program-page'
                      placeholder='请选择小程序页面'
                      data={xundaMiniprogramPageList}
                      value={wechatMsgInfo.miniprogramPage}
                      onChange={(e, value) => handleWelcomeMiniprogramInfoChange([{ type: 'miniprogramPage', value }])}                    
                      labelFieldName='pageName'
                      valueFieldName='path'
                    />
                  </FormGroup>
                </div>
              </li>}
              {wechatMsgInfo.isXundaMiniprogram === 0 && <li className="infolist">
                <span className="info-tt info-tt-read">小程序APPID</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.miniprogramAppId?.length ===0 ? "小程序APPID不能为空" : ''}
                  >
                    <Input
                      placeholder="请输入小程序APPID"
                      value={wechatMsgInfo.miniprogramAppId}
                      onChange={(e, value) => handleWelcomeMiniprogramInfoChange([{ type: 'miniprogramAppId', value }])}
                    />
                  </FormGroup>
                </div>
              </li>}
              {wechatMsgInfo.isXundaMiniprogram === 0 && <li className="infolist">
                <span className="info-tt info-tt-read">小程序消息标题</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.miniprogramTitle?.length ===0 ? "小程序消息标题不能为空" : ''}
                  >
                    <Input
                      placeholder="请输入小程序消息标题"
                      value={wechatMsgInfo.miniprogramTitle}
                      onChange={(e, value) => handleWelcomeMiniprogramInfoChange([{ type: 'miniprogramTitle', value }])}
                    />
                  </FormGroup>
                </div>
              </li>}
              {wechatMsgInfo.isXundaMiniprogram === 0 && <li className="infolist">
                <span className="info-tt info-tt-read">小程序消息封面</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.miniprogramPicUrl?.length ===0 ? "小程序消息封面不能为空" : ''}
                  >
                    <Uploader.ImageUploader
                      accept="image/bmp,image/png,image/jpeg,image/jpg,image/gif"
                      name="file"
                      style={{ marginTop: '10px' }}
                      headers={{ 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }}
                      url={`/api/v1/wx_work_msg/uploadfile?accountId=${window.pageProps.uid}&corpId=${window.pageProps.corpId }&csrfToken=${window.pageProps.token}&fileType=image`}
                      onComplete={handleUploadComplete}
                      onDelete={handleDelete}
                      value={selectedImage}
                      onUpload={() => {
                        setOperating(true);
                      }}
                    >
                      <label className="upimgbtn">本地上传</label>
                    </Uploader.ImageUploader>
                  </FormGroup>
                  {errorMessage !== '' && <div className="error-text">{errorMessage}</div>}
                </div>
              </li>}
              {wechatMsgInfo.isXundaMiniprogram === 0 && <li className="infolist">
                <span className="info-tt info-tt-read">小程序页面链接</span>
                <div className="info-des">
                  <FormGroup
                    error={check && wechatMsgInfo.miniprogramPage?.length ===0 ? "小程序页面链接不能为空" : ''}
                  >
                    <Input
                      placeholder="请输入小程序页面链接"
                      value={wechatMsgInfo.miniprogramPage}
                      onChange={(e, value) => handleWelcomeMiniprogramInfoChange([{ type: 'miniprogramPage', value }])}
                    />
                  </FormGroup>
                </div>
              </li>}
            </ul>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default WechatEditDialog;
